export default __webpack_public_path__ + "static/media/egg_video02.3ba4b9c4.jpg";